import request from './request';
import type { ResponseData, iDay } from '@/types/index'

// 活动info
export const getSecretBonusInfo = ({ activityId }: { activityId: string | number }) : Promise<ResponseData<iDay[]>> =>
  request({
    url: '/carbon-promotion/private/user/activity/mystery/bonus/homepage',
    method: 'GET',
    params: { activityId }
  });

// 活动info 无需权限
export const getSecretBonusInfoWithoutAuth = ({ activityId }: { activityId: string | number }) : Promise<ResponseData<iDay[]>> =>
  request({
    url: '/carbon-promotion/public/activity/mystery/bonus/homepage',
    method: 'GET',
    params: { activityId }
  });
